export const CONTRACT_STATE_TEMPLATE_API = "v1/contract-state-template";
export const PREDEFINED_TEMPLATE_API = "v1/pre-defined-template";
export const DOWNLOAD_PREDEFINED_TEMPLATE_API = "v1/docs/download";
